import React, { useEffect } from "react";
import "./ScrollGames.css";
import { useNavigate, useLocation } from "react-router-dom";
import Helper from "../../helper";
import Appconfig from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import { FaHome, FaFutbol, FaTrophy, FaBasketballBall } from "react-icons/fa";
import { BiSolidCricketBall, BiFootball, BiTennisBall } from "react-icons/bi";
import { GiHorseHead } from "react-icons/gi";
import { MdCasino, MdSportsSoccer } from "react-icons/md";
import { SiVirtualbox } from "react-icons/si";

// import "../../../src/App.css";

const ScrollGames = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const myState = location.state?.myKey;
  const userInfo = Helper();
  // console.log(myState);


  // Determine if Home is active
  // const isHomeActive = location.pathname === '/';
  const isHomeActive =
    location.pathname === "/" &&
    (props.eventType === undefined || props.eventType === null);

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => { if (myState == 'inplay') { props.setEventType("In-Play") } if (myState == "home") { props.setEventType(undefined) } }, [myState]);



  return (
    // <div className="scrollable-box">
    //   <div className="inner-box">
    //     <button className='box-button' type="button" value={4} onClick={(e) => props?.setEventType(e.target.value)}>Cricket</button>
    //     <button className='box-button-1' type="button" value={1} onClick={(e) => props?.setEventType(e.target.value)}>Football</button>
    //     <button className='box-button-3' type="button" value={2} onClick={(e) => props?.setEventType(e.target.value)}>Tennis</button>
    //     <button className='box-button-2' type="button" onClick={() => navigate('/ezugiLobby')}>Live Casino</button>
    //     <button className='box-button-4' type="button" onClick={() => CreateAndLaunchWCOCasino(`BT`)}>Sportsbook</button>
    //     <button className='box-button-5' type="button" onClick={() => navigate('/ezugiLobby', { state: { activeCasino: 'Evolution Gaming' } })}>Evolution</button>
    //     <button className='box-button-6' type="button" onClick={() => navigate('/ezugiLobby', { state: { activeCasino: 'Spribe' } })}>Slot Games</button>
    //     <button className='box-button-7' type="button" onClick={() => CreateAndLaunchWCOCasino(`EZ`, `321000`)}>Fortune Spin</button>
    //   </div>
    // </div>
    <div className="scrollgames-bar-container">
      <div className="scrollgames-bar">
        <div
          // className={`scrollgames-item${isHomeActive && !props.eventType ? " active" : ""
          //   }`}
          // onClick={() => {
          //   props.setEventType(undefined); // or null or 0, depending on your default
          //   navigate("/");
          // }}
          className={`scrollgames-item${props.eventType === "In-Play" ? " active " : ""
            }`}
          onClick={() => { props.setEventType("In-Play"); navigate('/', { state: { myKey: 'inplay', subSport: "live" } }); }}
        >
          {/* <FaHome size={20} color="#fff" /> */}
          <div className="flex flex-col  items-center ">
            <span className="dummy-icon1"></span>
            <span className="relative right-1  font-medium">In-Play</span>
          </div>
          {isHomeActive && !props.eventType && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 4 ? " active" : ""
            }`}
          onClick={() => { props.setEventType(4); navigate('/', { state: { myKey: 4 } }); }}
        >

          <div className="flex flex-col items-center">
            <span id="tagLive" class="tag-livemobile"><strong></strong>0</span>
            <span className="  dummy-icon2"></span>
            <span className="relative right-1  font-medium">Cricket</span>
          </div>
          {props.eventType === 4 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 1 ? " active" : ""
            }`}
          onClick={() => { props.setEventType(1); navigate('/', { state: { myKey: 1 } }); }}
        >
          {/* <BiSolidCricketBall size={20} color="#ff9800" /> */}
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M15.05 12.81L6.56 4.32a.996.996 0 00-1.41 0L2.32 7.15a.996.996 0 000 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83a.996.996 0 000-1.41zM14.341 17.756l1.414-1.414 4.243 4.243-1.414 1.414z"></path>
            <circle cx="18.5" cy="5.5" r="3.5"></circle>
          </svg> */}
          <div className="flex flex-col items-center">
            <span id="tagLive" class="tag-livemobile"><strong></strong>0</span>

            <span className="dummy-icon3"></span>
            <span className="relative right-1  font-medium" >Soccer</span>
          </div>
          {props.eventType === 1 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 2 ? " active" : ""
            }`}
          onClick={() => { props.setEventType(2); navigate('/', { state: { myKey: 2 } }); }}
        >
          <div >
            <span id="tagLive" class="tag-livemobile"><strong></strong>0</span>

            <span className="dummy-icon5"></span>
            <span className="relative right-1  font-medium">Tennis</span>
          </div>
          {props.eventType === 2 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 14 ? " active" : ""
            }`}
          onClick={() => props.setEventType(14)}
        >
          {/* <BiTennisBall size={20} color="#4caf50" /> */}
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M250.4 464c1-7.9 1.6-15.9 1.6-23.9 0-48.1-18.7-94.3-52.7-128.3S119 260 70.9 260c-7.7 0-15.4.5-22.9 1.4 2.8 110.3 92.3 199.3 202.4 202.6z"></path>
            <path d="M230 74c0-8.3.5-16.4 1.4-24.5-95.3 11.7-171.7 89-182.2 184.7 7.2-.7 14.4-1.1 21.8-1.1 114.9 0 207.1 92.2 207.1 207 0 7.7-.4 15.3-1.3 22.8 96.6-10.1 174.6-86.2 185.8-182.4-8.4 1-16.9.6-25.5.6C322.1 281 230 188.9 230 74z"></path>
            <path d="M308.7 202.3c34 34 80.2 52.7 128.3 52.7 9.1 0 18.1-.7 27-2-2.2-112-93.9-203.5-206.1-205-1.2 8.5-1.9 17.2-1.9 26 0 48.1 18.7 94.3 52.7 128.3zM232 49.3z"></path>
          </svg> */}
          {/* <div className="">
            <span id="tagLive" class="tag-livemobile"><strong></strong>0</span>
            <span className="dummy-icon6"></span>
            <span className="relative right-1 font-medium">Horse</span>
          </div>
          {props.eventType === 2 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 15 ? " active" : ""
            }`}
          onClick={() => props.setEventType(15)}
        > */}
          {/* <GiHorseHead size={20} color="#795548" /> */}
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M400 16c-21.335 9.73-58.244 17.34-73.086 48.232-22.36 1.948-72.753 10.673-122.22 40.25-58.098 34.74-116.017 97.417-131.776 213.702l-.48 3.537-2.774 2.25c-30.87 25.002-40.657 38.937-44.416 61.153-3.536 20.9-.72 51.46-.363 101.877H328.36c3.455-16.892 10.44-29.245 12.472-41.568 2.337-14.176.19-29.938-20.812-58.547-43.078-58.683-46.853-129.458-12.916-171.28-8.654-2.765-15.09-6.887-19.458-12.546-6.115-7.924-7.4-17.006-8.57-25.884l17.848-2.352c1.112 8.446 2.38 13.88 4.97 17.237 2.59 3.356 7.31 6.472 19.55 8.46l-.022.128.172-.17 5.998 9.424c19.957 31.358 42.84 51.292 73.332 54.44l6.51.672 1.367 6.4c2.74 12.828 8.626 19.095 15.116 22.238 6.49 3.143 14.225 2.944 20.47.205 9.316-4.086 14.518-11.35 16.7-22.712 2.122-11.05.546-25.834-5.137-42.106-33.538-38.248-44.475-87.277-63.903-128.772-6.055-9.947-12.448-18.518-20.385-24.856C376.808 55.126 386.456 34.852 400 16zM214.068 34.97C179.55 35.06 146.075 43.06 96 58.58c31.146 9.92 70.397 18.9 86.037 39.01 4.463-3.017 8.94-5.88 13.418-8.56 40.51-24.22 80.387-35.286 108.23-40.04-35.854-9.477-63.047-14.094-89.617-14.023zM157.16 96.712c-1.13-.01-2.265-.01-3.402.004-30.353.37-63.1 9.745-96.647 31.283 27.186 3.672 54.67 3.724 72.58 15.398 15.9-17.92 33.144-32.634 50.677-44.668-7.548-1.244-15.292-1.938-23.207-2.017zM368 128a13.214 13.215 0 0 1 13.213 13.215A13.214 13.215 0 0 1 368 154.432a13.214 13.215 0 0 1-13.213-13.217A13.214 13.215 0 0 1 368 128zm-238.906 16.068c-36.395 1.495-68.903 6.53-104.76 24.766 33.236 7.095 50.913 13.507 65.025 33.83 11.522-22.53 25.045-41.93 39.734-58.596zM74.518 201.46C53.53 201.65 36.614 213.14 16 224c27.854 0 46.067 3.862 58.71 12.055 4.33-11.652 9.16-22.615 14.41-32.924-5.12-1.19-9.963-1.71-14.602-1.67zm-.623 36.82c-17.933 5.845-35.452 7.15-54.23 22.284 17.62 4.638 34.79 9.596 41.398 22.034 3.496-15.77 7.814-30.523 12.832-44.32zm370.142 8.57c1.617-.035 3.222.044 4.783.187l-1.64 17.926c-3.928-.36-5.513.416-5.57.465-.058.048-1.035.656-.635 5.886l-17.95 1.372c-.638-8.35 1.297-16.207 6.955-20.997 4.245-3.593 9.206-4.735 14.057-4.84zM52.215 290.723c-10.352.13-23.76 5.646-34.656 12.334 12.173 6.83 12.357 23.472 8.938 37.668 7.3-9.105 16.855-18.323 29.158-28.48 1.016-7.043 2.19-13.9 3.506-20.585-2.082-.67-4.42-.97-6.947-.937z"></path>
          </svg> */}
          {/* <div>
            <span id="tagLive" class="tag-livemobile1 tagmobiles"><strong></strong>0</span>

            <span className="dummy-icon7"></span>
            <span className="relative right-2  font-medium">GreyHound</span>
          </div>
          {props.eventType === 11 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 16 ? " active" : ""
            }`}
          onClick={() => props.setEventType(16)}
        > */}
          {/* <MdCasino size={20} color="#e91e63" /> */}
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M386.688 487.75l-119.236-55.423c-7.898-3.673-11.334-13.065-7.66-20.976l84.374-181.523c3.667-7.904 13.07-11.334 20.963-7.667l119.24 55.434c7.9 3.673 11.33 13.065 7.656 20.964l-84.37 181.524c-3.678 7.904-13.076 11.334-20.968 7.667zM98.95 467.945L19.79 284.09c-3.448-8.007.255-17.302 8.25-20.744l39.196-16.872 48.975 184.044c4.694 17.588 22.755 28.078 40.36 23.39l39.032-10.386-75.907 32.686c-8.007 3.443-17.296-.255-20.744-8.262zm33.89-41.86L81.362 232.638c-2.24-8.42 2.78-17.078 11.19-19.312l34.033-9.052-4.098 30.465c-2.422 18.036 10.224 34.652 28.285 37.087l79.828 10.758-32.497 109.467c-3.345 11.28-.37 22.948 6.866 31.18l-52.82 14.05c-8.42 2.24-17.07-2.77-19.31-11.196zm108.428-4.76l-16.02-4.76c-8.36-2.49-13.12-11.267-10.644-19.627l56.97-191.9c2.484-8.36 11.28-13.12 19.622-10.65l49.073 14.583.008-.005.12.044-.133-.034c-4.93 3.254-9.04 7.868-11.705 13.605l-84.38 181.53c-2.587 5.586-3.486 11.517-2.915 17.218zm-5.707-155.43l-82.486-11.117c-8.633-1.166-14.704-9.12-13.538-17.758l26.73-198.39c1.16-8.633 9.125-14.698 17.74-13.538l130.327 17.563c8.627 1.166 14.692 9.125 13.532 17.752L311.42 182.46l-15.33-4.552c-17.467-5.197-35.826 4.784-41.004 22.232l-19.525 65.755zm-5.19-31.46c4.67-3.055 7.474-7.438 8.42-13.145.936-5.633-.357-10.617-3.866-14.945-3.51-4.414-8.39-7.14-14.656-8.178-6.344-1.057-11.93-.073-16.75 2.956-4.826 3.03-7.692 7.316-8.615 12.87-.898 5.386.425 10.42 3.97 15.082 3.565 4.504 8.525 7.285 14.863 8.34 6.35 1.057 11.893.062 16.634-2.98zm25.978-81.243c4.693-2.726 8.888-5.434 12.598-8.117 3.703-2.684 6.915-5.586 9.635-8.725 2.72-3.13 4.967-6.573 6.733-10.307 1.76-3.74 3.048-8.032 3.85-12.865 1.262-7.62 1.02-14.358-.735-20.234-1.75-5.87-4.693-10.94-8.833-15.22-4.135-4.27-9.24-7.753-15.318-10.43-6.07-2.684-12.804-4.633-20.174-5.86-7.692-1.28-15.3-1.602-22.815-.977-7.516.614-14.63 2.247-21.346 4.88l-5.95 35.802c6.813-4.25 13.77-7.104 20.855-8.567 7.09-1.475 13.726-1.7 19.913-.668 21.467 4.092 19.44 24.898 8.76 34.03-5.652 4.473-11.334 8.802-15.942 11.345-10.48 5.914-27.69 23.125-22.542 45.145l31.284 5.202c-7.11-17.757 11.663-29.462 20.028-34.434z"></path>
          </svg> */}
          <div className="flex flex-col items-center">
            <span className="dummy-icon8"></span>
            <span className="relative right-3  font-medium">Ludo Cricket</span>
          </div>
          {props.eventType === 10 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 17 ? " active" : ""
            }`}
          onClick={() => props.setEventType(17)}
        >
          {/* <MdSportsSoccer size={20} color="#9c27b0" /> */}
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M331.088 488.95l-101.23-47.053c-6.698-3.122-9.62-11.094-6.503-17.815l71.63-154.11c3.117-6.71 11.1-9.624 17.804-6.508l101.23 47.066c6.71 3.115 9.62 11.088 6.51 17.797l-71.64 154.11c-3.12 6.714-11.098 9.618-17.802 6.514zM86.8 472.134L19.596 316.04c-2.927-6.797.218-14.686 7.004-17.607l33.275-14.328 41.578 156.25c3.99 14.937 19.32 23.84 34.267 19.864l33.14-8.823-64.445 27.752c-6.798 2.92-14.687-.22-17.614-7.017zm28.774-35.535L71.87 272.362c-1.905-7.152 2.362-14.498 9.502-16.398l28.89-7.683-3.475 25.864c-2.06 15.313 8.68 29.423 24.01 31.488l67.774 9.135-27.586 92.934c-2.845 9.578-.313 19.486 5.83 26.472l-44.847 11.926c-7.146 1.906-14.493-2.35-16.393-9.5zm92.055-4.043l-13.603-4.042c-7.1-2.112-11.14-9.565-9.034-16.664l48.364-162.92c2.112-7.1 9.577-11.14 16.658-9.04l41.667 12.38.006-.006.112.035-.118-.03c-4.19 2.76-7.677 6.68-9.937 11.547L210.1 417.944c-2.194 4.733-2.96 9.772-2.47 14.61zm-4.846-131.957l-70.033-9.44c-7.328-.992-12.48-7.743-11.494-15.078l22.695-168.43c.987-7.33 7.75-12.48 15.06-11.496l110.65 14.912c7.322.99 12.48 7.748 11.488 15.07l-13.96 103.622-13.02-3.866c-14.828-4.408-30.412 4.066-34.808 18.878l-16.576 55.828zm253.322-8.668l-7.253-15.94 37.418-16.98 7.23 15.95-37.394 16.97zm-9.353-27.805l-32.792-72.222c11.484-2.738 22.354-7.624 32.026-14.41l32.726 72.133-31.96 14.5zm-83.41-88.155c-41.006-16.174-61.152-62.585-44.977-103.603 16.18-40.993 62.603-61.15 103.603-44.977 41.01 16.18 61.15 62.604 44.982 103.62-16.187 40.995-62.604 61.147-103.61 44.96zm86.378-51.78c12.434-31.488-3.038-67.135-34.55-79.563-31.493-12.427-67.14 3.045-79.58 34.544-12.427 31.5 3.05 67.16 34.557 79.58 31.5 12.43 67.146-3.043 79.574-34.56zm-30.106-16.96c1.96-22.547-12.634-42.758-33.676-48.653 3.86-.732 7.9-.956 12.014-.602 24.27 2.1 42.292 23.492 40.197 47.768-2.078 23.94-22.914 41.79-46.766 40.274 15.366-6.48 26.702-21.03 28.23-38.787z"></path>
          </svg> */}
          <div>
            <span className="dummy-icon8"></span>
            <span>Indian Poker</span>
          </div>
          {props.eventType === 12 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 18 ? " active" : ""
            }`}
          onClick={() => props.setEventType(18)}
        >
          {/* <SiVirtualbox size={20} color="#607d8b" /> */}
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 00352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 00-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0018.64 3.22c29.93 0 53.93-24.93 70.33-45.34 18.53-23.1 40.22-34.82 107.34-34.82 59.95 0 84.76 8.13 106.19 34.82 13.47 16.78 26.2 28.52 38.9 35.91 16.89 9.82 33.77 12 50.16 6.37 25.82-8.81 40.62-32.1 44-69.24 2.57-28.48-1.39-65.89-12.12-114.37zM208 240h-32v32a16 16 0 01-32 0v-32h-32a16 16 0 010-32h32v-32a16 16 0 0132 0v32h32a16 16 0 010 32zm84 4a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-19.95A20 20 0 01336 288zm0-88a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20z"></path>
          </svg> */}
          <div>
            {/* <span className="dummy-icon7"></span> */}
            <img src="\Images\aviator-icon.svg" alt="Aviatior Icon" className="w-[30px] ml-5" />
            <span>Aviatior</span>

          </div>
          {props.eventType === 847885 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 6 ? " active" : ""
            }`}
          onClick={() => props.setEventType(6)}
        >
          {/* <FaBasketballBall size={20} color="#ff5722" /> */}
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M256 23C140.57 23 73.01 90.16 24.283 171.37L23 173.507V309.85l142.268 63.228C175.353 408.092 183 436.353 183 480h18c0-2.378-.028-4.703-.07-7h22.304l.405 7.484 17.973-.968-.35-6.516h29.14l-.366 6.496 17.973 1.008.422-7.504h22.64c-.042 2.3-.072 4.624-.072 7h18c0-43.265 7.505-72.296 17.453-106.797L489 309.85V173.508l-1.283-2.14C438.99 90.16 371.43 23 256 23zm0 18c107.607 0 167.912 59.792 215 137.563V298.15l-118.027 52.457c1.952-6.838 3.947-14.016 5.96-21.607H384v-34h-23V167H151v128h-23v34h25.023c1.965 7.597 3.906 14.745 5.81 21.52L41 298.15V178.563C88.088 100.793 148.393 41 256 41zm-87 144h174v110H169V185zm2.61 144h43.863l1.617 30h-37.115c-2.71-9.403-5.528-19.275-8.364-30zm61.888 0h44.982l-1.683 30h-41.682l-1.617-30zm63.012 0h43.804c-2.88 10.63-5.75 20.51-8.507 30h-36.98l1.683-30zm-111.377 48h32.928l1.618 30h-26.756c-2.27-10.02-4.922-19.86-7.79-30zm50.953 0h39.7l-1.682 30h-36.4l-1.618-30zm57.73 0h32.825c-2.83 10.065-5.443 19.92-7.683 30h-26.824l1.683-30zm-97.308 48h24.14l1.618 30h-22.14c-.762-10.673-2.002-20.55-3.618-30zm42.166 0h34.422l-1.684 30h-31.12l-1.618-30zm52.45 0h24.31c-1.59 9.476-2.808 19.37-3.563 30h-22.43l1.685-30z"></path>
          </svg> */}
          <div>
            <span className="dummy-icon11"></span>
            <span>AE Sexy</span>

          </div>
          {props.eventType === 6 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 19 ? " active" : ""
            }`}
          onClick={() => props.setEventType(19)}
        >
          {/* <FaTrophy size={20} color="#FFD700" /> */}
          <div>
            <span className="dummy-icon8"></span>
            <span>Evolution</span>
          </div>
          {props.eventType === 99 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 20 ? " active" : ""
            }`}
          onClick={() => props.setEventType(20)}
        >
          {/* <FaTrophy size={20} color="#FFD700" /> */}
          <div>
            <span className="dummy-icon9"></span>
            <span>Live Casino</span>
          </div>
          {props.eventType === 99 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 21 ? " active" : ""
            }`}
          onClick={() => props.setEventType(21)}
        >
          {/* <FaTrophy size={20} color="#FFD700" /> */}
          <div className="flex flex-col items-center justify-center ">
            <span className="dummy-icon14"></span>
            <span>VIVO</span>
          </div>
          {props.eventType === 99 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 22 ? " active" : ""
            }`}
          onClick={() => props.setEventType(22)}
        >
          {/* <FaTrophy size={20} color="#FFD700" /> */}
          <div>
            <span className="dummy-icon11"></span>
            <span>More</span>
          </div>
          {props.eventType === 99 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 23 ? " active" : ""
            }`}
          onClick={() => props.setEventType(23)}
        >
          {/* <FaTrophy size={20} color="#FFD700" /> */}
          <div className="flex flex-col items-center" >
            <span className="dummy-icon12 "></span>
            <span>BET GAME</span>
          </div>
          {props.eventType === 99 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>
        <div
          className={`scrollgames-item${props.eventType === 24 ? " active" : ""
            }`}
          onClick={() => props.setEventType(24)}
        >
          {/* <FaTrophy size={20} color="#FFD700" /> */}
          <div className="flex flex-col items-center justify-center ">
            <span className="dummy-icon13"></span>
            <span className="relative right-1  font-medium">CASINO III</span>
          </div>
          {props.eventType === 99 && (
            <div className="scrollgames-triangle"></div>
          )}
        </div>

      </div>
    </div >
  );
};

export default ScrollGames;
